import type { LayoutBlock } from '@web-studio/shared-schemas';
import { allergyCaptureSecureFormDefault } from '../blocks/allergyForm';
import { chefStoryBlockDefault } from '../blocks/chefStory';
import { dynamicMenuFlowDefault } from '../blocks/dynamicMenu';
import { footerStandardDefault } from '../blocks/footer';
import { heroEditorialDefault } from '../blocks/hero';
import { heroVideoAtmosphereDefault } from '../blocks/heroVideo';
import { menuGrid3ColumnDefault } from '../blocks/menu';
import { navigationHeaderDefault } from '../blocks/navigation';
import { reservationFormEmbedDefault } from '../blocks/reservationForm';
import { tastingMenuCourseTimelineDefault } from '../blocks/tastingTimeline';

const MENU_IMAGE =
  'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1400&q=80';

/** Restaurant / plus — default starters + all optional add-ons for full-stack preview. */
export const restaurantPlusPage: LayoutBlock[] = [
  { ...navigationHeaderDefault, displayOrder: 0 },
  { ...heroEditorialDefault, displayOrder: 1 },
  {
    ...menuGrid3ColumnDefault,
    displayOrder: 2,
    media: { ...menuGrid3ColumnDefault.media, menuImage: MENU_IMAGE },
  },
  {
    ...dynamicMenuFlowDefault,
    displayOrder: 3,
    media: { ...dynamicMenuFlowDefault.media, menuImage: MENU_IMAGE },
  },
  { ...reservationFormEmbedDefault, displayOrder: 4 },
  { ...chefStoryBlockDefault, displayOrder: 5 },
  { ...tastingMenuCourseTimelineDefault, displayOrder: 6 },
  { ...allergyCaptureSecureFormDefault, displayOrder: 7 },
  { ...heroVideoAtmosphereDefault, displayOrder: 8 },
  { ...footerStandardDefault, displayOrder: 9 },
];
